import { render } from "./AttendancePeriodDetailsDialog.vue?vue&type=template&id=3920a82a&scoped=true"
import script from "./AttendancePeriodDetailsDialog.vue?vue&type=script&lang=js"
export * from "./AttendancePeriodDetailsDialog.vue?vue&type=script&lang=js"

import "./AttendancePeriodDetailsDialog.vue?vue&type=style&index=0&id=3920a82a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3920a82a"]])

export default __exports__